import { createApiService } from './createApiService'

export interface Setting {
  id: string;
  value: string;
  inputType?: string;
  label?: string;
  options?: Array<{
    value: string;
    label: string;
  }>;
}

export const settingsAPI = createApiService({
  reducerPath: 'settingsAPI',
  tagTypes: ['Settings'],
  endpoints: (build: any) => ({
    getAllSettings: build.query({
      query: () => '/settings',
      providesTags: ['Settings'],
    }),
    getSettingsDefinitions: build.query({
      query: () => '/settings/definitions',
      providesTags: ['Settings'],
    }),
    getSettingsWithDefinitions: build.query({
      query: () => '/settings/with-definitions',
      providesTags: ['Settings'],
    }),
    getSetting: build.query({
      query: (id: string) => `/settings/${id}`,
      providesTags: (result: any, error: any, id: string) => [{ type: 'Settings', id }],
    }),
    updateSetting: build.mutation({
      query: ({ id, value }: { id: string; value: string }) => ({
        url: `/settings/${id}`,
        method: 'PUT',
        body: { value },
      }),
      invalidatesTags: ['Settings'],
    }),
  }),
})

export const {
  useGetAllSettingsQuery,
  useGetSettingsDefinitionsQuery,
  useGetSettingsWithDefinitionsQuery,
  useGetSettingQuery,
  useUpdateSettingMutation,
} = settingsAPI